'use strict';

export default {

    /**
     * Get the current user
     */
    current() {
        return new Promise((resolve, reject) => {
            axios({
                method: 'get',
                url: '/api/user',
                headers: {
                    'Accept': 'application/json'
                },
                params: {
                    includes: 'reusable_payments'
                }
            })
            .then(response => {
                resolve(response.data);
            }).catch(errors => {
                reject(errors);
            });
        });
    },

    /**
     * Get the addresses for the current user
     */
    getAddresses() {
        return new Promise((resolve, reject) => {
            axios({
                method: 'get',
                url: '/api/users/addresses',
                headers: {
                    'Accept': 'application/json'
                }
            })
            .then(response => {
                resolve(response.data);
            }).catch(errors => {
                reject(errors);
            });
        });
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/Services/User.js